import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-container-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_drop_down = _resolveComponent("k-drop-down")!
  const _component_error = _resolveComponent("error")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_k_drop_down, {
      id: _ctx.id,
      label: _ctx.computedLabel,
      "data-items": _ctx.filteredData,
      value: _ctx.currentValue,
      "value-primitive": true,
      "value-field": _ctx.valueField,
      "data-item-key": _ctx.valueField,
      "text-field": _ctx.textField,
      filterable: _ctx.filterable,
      "default-item": _ctx.defaultItem,
      style: _normalizeStyle(_ctx.widthStyle),
      onFilterchange: _ctx.onFilterChange,
      onChange: _ctx.onChange
    }, null, 8, ["id", "label", "data-items", "value", "value-field", "data-item-key", "text-field", "filterable", "default-item", "style", "onFilterchange", "onChange"]),
    _withDirectives(_createVNode(_component_error, { id: _ctx.errorId }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
      ]),
      _: 1
    }, 8, ["id"]), [
      [_vShow, _ctx.showError]
    ])
  ]))
}